import { LoadingButton } from "@mui/lab";
import { Button, Stack, TableCell, TableRow } from "@mui/material";
import { useContext } from "react";
import { RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

type Props = { reset: () => void };

export default function RowAddRedirectForm({ reset }: Props) {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	const onCancel = () => {
		actions.hideCreateRow();
		reset();
	};

	return (
		<TableRow>
			<TableCell align={"left"}>
				<RHFTextField
					name='name'
					variant='standard'
					label={translate("api_client.add_name")}
					autoFocus
				/>
			</TableCell>
			<TableCell align={"left"}>
				<RHFTextField
					name='redirectURI'
					variant='standard'
					label={translate("api_client.add_url")}
				/>
			</TableCell>
			<TableCell align={"left"}>
				<Stack flexDirection='row' alignItems='center' gap={2} justifyContent={"left"}>
					<LoadingButton variant='text' type='submit' loading={false}>
						{translate("api_client.save")}
					</LoadingButton>
					<Button color='inherit' variant='text' onClick={onCancel} disabled={false}>
						{translate("api_client.cancel")}
					</Button>
				</Stack>
			</TableCell>
		</TableRow>
	);
}
